import { Component, OnInit } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';


@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {
 
  constructor(private session: SessionStorageService, private routes: Router) { }

  ngOnInit() {
    
    if(this.session.retrieve('token')) {
      
      this.routes.navigate(['/main/transactions']);
        
    }  else {
      this.routes.navigate(['/login']); 
        }
  }

}
